import { useTranslation } from 'react-i18next';
import { useRoutes } from 'react-router-dom';
import { OperationsIDPage, OperationsPage } from './pages';
import { useOperations } from './providers/OperationsProvider';
import { RoutesName } from './state/constants';

export const OperationsModule = () => {
  const { t } = useTranslation();
  const { token } = useOperations();

  const routes = useRoutes([
    {
      path: RoutesName.operations,
      children: [
        {
          element: (
            <OperationsPage
              detailRoute={`${RoutesName.operationsList}/${RoutesName.operationsId}`}
            />
          ),
          index: true,
        },
        {
          path: RoutesName.operationsId,
          element: (
            <OperationsIDPage
              token={token || undefined}
              emptyBackRoute={RoutesName.operationsList}
              emptyBackText={t('Back to the operation list')}
            />
          ),
        },
      ],
    },
  ]);

  return <>{routes}</>;
};
